const ADMIPROFS_BUSINESSES_WITH_INVOICING = new Set([
    'fbbb3cfc-fc96-45b9-88d7-09c35d3a51a8',
    'e9d3b939-a0d0-4cd9-b4f3-bc81eee84abc',
    'd50c815c-d7fa-43c8-8fa6-7dcfbd02667c',
    '7e189470-397c-40b0-8b34-fd44977d05cd',
    'c8ec18c9-dbfb-41c9-88f0-b70189f6481f',
    '2bc37adf-f543-4f21-af95-ba9406c56baf',
])

function isAdmiprofsHost(hostname: string): boolean {
    return hostname.toLowerCase().includes('admiprofs')
}

function hasInvoicingException(businessIds: string[]): boolean {
    return businessIds.some((businessId) => ADMIPROFS_BUSINESSES_WITH_INVOICING.has(businessId))
}

export function canUseInvoicing(businessIds: string[], hostname: string = window.location.hostname): boolean {
    return !isAdmiprofsHost(hostname) || hasInvoicingException(businessIds)
}
